export const getStateSelectFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
